export default "__VITE_ASSET__BkSku5G5__$_?url__"